module.exports = __webpack_public_path__ + "img/vertical_6_3_8003.28cead77.png";